import React, { useEffect, useRef, useState } from "react";
import { Pause, Play } from "lucide-react";

const VIDEO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_spire-support-hub/artifacts/py320jqj_VID-20260626-WA0028.mp4";

export const HeroVideo = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce && videoRef.current) {
      videoRef.current.pause();
      setPlaying(false);
    }
  }, []);

  const toggle = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play().catch(() => setFailed(true));
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  if (failed) {
    return (
      <div
        className="relative mx-auto w-56 sm:w-64 lg:w-72 shrink-0 motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-6 motion-safe:duration-1000"
        data-testid="hero-video-frame"
      >
        <div className="overflow-hidden rounded-[2rem] border-4 border-white/20 shadow-2xl shadow-stone-950/50">
          <img
            src="https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/eag9kq0v_IMG-20260612-WA0026.jpg"
            alt="Someone we support proudly presenting a homemade pizza they prepared in a cooking session."
            className="aspect-[9/16] w-full object-cover"
          />
        </div>
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-orange-600 px-4 py-1 text-sm font-semibold text-white shadow-lg">
          Life at Spire
        </span>
      </div>
    );
  }

  return (
    <div
      className="relative mx-auto w-56 sm:w-64 lg:w-72 shrink-0 motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-bottom-6 motion-safe:duration-1000"
      data-testid="hero-video-frame"
    >
      <div className="overflow-hidden rounded-[2rem] border-4 border-white/20 shadow-2xl shadow-stone-950/50">
        <video
          ref={videoRef}
          src={VIDEO_URL}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          onError={() => setFailed(true)}
          aria-label="A short clip of life at Spire Inclusion — someone we support preparing food in a cooking session."
          className="aspect-[9/16] w-full object-cover"
          data-testid="hero-video"
        />
      </div>
      <button
        onClick={toggle}
        aria-label={playing ? "Pause video" : "Play video"}
        className="absolute bottom-3 right-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-stone-950/70 text-white backdrop-blur transition-colors hover:bg-stone-950/90"
        data-testid="hero-video-toggle"
      >
        {playing ? <Pause className="h-4 w-4" aria-hidden="true" /> : <Play className="h-4 w-4 ml-0.5" aria-hidden="true" />}
      </button>
      <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-orange-600 px-4 py-1 text-sm font-semibold text-white shadow-lg">
        Life at Spire
      </span>
    </div>
  );
};
